import { useState, useEffect, useRef } from "react";
import { jsx } from "react/jsx-runtime";
import "./VBR.css";
import { ParallaxProvider } from "react-scroll-parallax";

function VBR() {
  const [activeDate, setActiveDate] = useState("2025/01");
  const historySectionRef = useRef(null);
  const VBRPageRef = useRef(null);

  const dates = ["2025/01", "2025/02", "2025/04", "2025/06", "2025/11", "2025/12"];

  const backgroundImages = {
    "2025/01": "/VBR/thumb.png",
    "2025/02": "/VBR/kaisetu.jpg",
    "2025/04": "/VBR/funaken.png",
    "2025/06": "/VBR/allstar.jpg",
    "2025/11": "/VBR/yukishiro.png",
    "2025/12": "/VBR/grandprix.jpg",
  };

  const scrollToDate = (date) => {
    const element = document.getElementById(`section-${date}`);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
      setActiveDate(date);
    }
  };

  useEffect(() => {
    const pageElement = VBRPageRef.current;
    if (!pageElement) return;

    const handleScroll = () => {
      let currentActiveDate = "2025/01";
      
      dates.forEach((date) => {
        const section = document.getElementById(`section-${date}`);
        if (section) {
          const rect = section.getBoundingClientRect();
          if (rect.top <= window.innerHeight / 2) {
            currentActiveDate = date;
          }
        }
      });
      
      setActiveDate(currentActiveDate);
    };

    pageElement.addEventListener("scroll", handleScroll);
    return () => pageElement.removeEventListener("scroll", handleScroll);
  }, [dates]);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
        }
      });
    }, {
      threshold: 0.1,
    });

    dates.forEach((date) => {
      const section = document.getElementById(`section-${date}`);
      if (section) {
        observer.observe(section);
      }
    });

    return () => observer.disconnect();
  }, [dates]);

  return (
    
    <div className="VBR-page" ref={VBRPageRef}>
     <title>VBR</title>
      <div className="introduction">
         <h2>VBR</h2>
        <p>
          VBRは、私が立ち上げた団体、「VRChat BOAT RACE」の略称です。
          <br />
          ここでは、その活動・概要について記載します。
        </p>
      </div>
      

      <div className="history" ref={historySectionRef}>
        <section id="section-2025/01" style={{ backgroundImage: `url('${backgroundImages["2025/01"]}')` }}>
          <h2>2025/01</h2>
        <h3>VRChat BOAT RACE・BOAT RACE 虫恋開設</h3>
        <p>
          2025年1月13日。「BOAT RACE
          虫恋」は産声を上げました。また、それと同時に「VRChat BOAT
          RACE」の活動も開始しました。
          <br />
          開設当初の本場は、大時計も動かず、スタンドもない簡素な造りでしたが、それでも「フライングスタート方式でのレースができる」
          <br />
          ということで、一定数の支持を得ました。
          <br />
        </p>
        </section>
        <section id="section-2025/02" style={{ backgroundImage: `url('${backgroundImages["2025/02"]}')` }}>
          <h2>2025/02</h2>
        <h3>初のグレードレース開催</h3>
        <p>
          2025年2月8日。「BOAT RACE
          虫恋」がパブリックワールドとなったことを記念し、
          <br />
          開設当初の本場は、初のグレードレース「G2
          ボートレース虫恋開設記念」が開催されました。
          <br />
          初開催ながら、出走選手は24名、フルインスタンスでの開催となりました。
          <br />
          レースは、4コースから.421のスタートながら道中冷静に捌いた、4号艇「やそちん」が優勝。
          <br />
          VBRの歴史に名を刻みました。
          <br />
        </p>
        </section>
        <section id="section-2025/04" style={{ backgroundImage: `url('${backgroundImages["2025/04"]}')` }}>
          <h2>2025/04</h2>
        <h3>舟券発売の開始</h3>
        <p>
          2025年4月5日。「G3 ルーキーシリーズ
          若草賞」より、舟券の発売が開始されました。
          <br />
          VRChatでは初となる、2連単のみの投票ながら、マークシート・舟券ギミックにより、来場者も増加しました。
          <br />
        </p>
        <h3>初のG1開催</h3>
        <p>
          2025年4月12日。初のG1、「G1 NEW WAVE CUP」が開催されました。
          <br />
          レースは4コースから.132のスタートで、6号艇「さいさい」が差しぬけての勝利。
          <br />
          一般戦2つの優勝はフロックではないと証明してみせました。
          <br />
        </p>
        </section>
        <section id="section-2025/06" style={{ backgroundImage: `url('${backgroundImages["2025/06"]}')` }}>
          <h2>2025/06</h2>
        <h3>初のSG開催</h3>
        <p>
          2025年6月14日。ファン投票によって選ばれた18名により、「SG VBR ALL
          STAR(コーシー記念)」が開催されました。
          <br />
          レースはファン投票4位の3号艇「ken」がチルト3度、5コースから.013のトップタイミングのスタートを決め、
          <br />
          1周2マーク抜きでの勝利。ここから最強伝説は始まりました。
          <br />
        </p>
        </section>
        <section id="section-2025/11" style={{ backgroundImage: `url('${backgroundImages["2025/11"]}')` }}>
          <h2>2025/11</h2>
        <h3>第二場、「BOAT RACE 雪城」公開</h3>
        <p>
          蒲郡をモチーフとした、「BOAT RACE 雪城」が公開されました。
          <br />
          VBR初のナイター場として開設され、虫恋とは異なる走り方が求められました。
          <br />
        </p>
        </section>
        <section id="section-2025/12" style={{ backgroundImage: `url('${backgroundImages["2025/12"]}')` }}>
          <h2>2025/12</h2>
        <h3>初のグランプリ開催</h3>
        <p>
          2025年12月20日・21日、二日間に渡って「GP VBR GRAND
          PRIX(虫恋記念)」が開催されました。
          <br />
          レースは2コースから.088のトップスタートから1マーク差しぬけた「もちかわ」が優勝。
          <br />
          クエスト単機でも問題なく言勝てることを証明しました。
          <br />
        </p>
        </section>
      </div>
      {/* <div className="raceCourse">
        <h2>場一覧</h2>
        <p>現在、VBRには3つの場が採用されています。各場に関する情報です。</p>
        <div className="mushikoi">
            <h2>#01 虫恋</h2>
            <p>VBR発祥の地。ホーム・バック側双方広々と作られており、様々な決まり手が見られる。</p>
            開設日: 2025年1月13日<br/>
            モチーフ: 兵庫県、尼崎<br/>
            スタート・周回展示曲:告白→始まりのファンファーレ

        </div>
        <div className="yukishiro">
            <h2>#02 雪城</h2>
            <p>VBR初のナイター場。1マークがホーム側に大きく振られており、逃げづらく、差しづらい。</p>
              開設日: 2025年4月3日<br/>
            モチーフ: 愛知県、蒲郡<br/>
            スタート・周回展示曲:星空に願いを

        </div>
        <div className="mashiro">
            <h2>#03 眞白</h2>
            <p>VBR初の薄暮場。バック側にピットがあり、ダッシュ水域も210mと短い。</p>
              開設日: 2026年3月8日<br/>
            モチーフ: 福岡県、福岡<br/>
            スタート・周回展示曲:夕焼けの約束

        </div>
      </div> */}
    </div>
  );
}
export default VBR;
